export default __webpack_public_path__ + "static/media/two-crite-1-splash.478009ea.svg";